import React from "react";
import { isNullOrUndefined } from "../../utils";
import { AddFlex, CustomText } from "../../reusableStyles";
import { Restore } from "@mui/icons-material";

function SuccessChip({
  successChipText,
  setIsConfirmActionDialogOpen,
  showIcon,
  icon,
  disableAction,
  action,
}) {
  return (
    <AddFlex
      backgroundColor="#ECFDF3"
      border={`2px solid ${"#ABEFC6"}`}
      alignItems="center"
      padding="5px 10px"
      borderRadius="16px"
      onClick={() => {
        if (disableAction) return;
        if (isNullOrUndefined(action)) {
          setIsConfirmActionDialogOpen(true);
        } else {
          action();
        }
      }}
    >
      <CustomText
        style={{
          borderRight: showIcon && "1px solid #ABEFC6",
          paddingRight: "4px",
        }}
        fontSize="12px"
        fontWeight="500"
        color="#067647"
        margin={showIcon && "0 5px 0 0"}
      >
        {successChipText ? successChipText : "Attended"}
      </CustomText>

      {showIcon && (
        <Restore
          style={{ paddingLeft: "0px", color: "#067647", fontSize: "16px" }}
        />
      )}
    </AddFlex>
  );
}

export default SuccessChip;
